




































import { Vue, Component, Prop } from "vue-property-decorator";
import * as activity from "../../_store/activity.module";
import * as data from "../../_store/data.module";
import * as user from "../../_store/user.module";
import { bus } from "../../main";
import { router } from "../../_router";
import * as temp from "../../_store/temp.module";

@Component
export default class ColloquiSubscriptionDialog extends Vue {
  private dialog: boolean;
  private articolazioni: any;
  private idIstituto: number;
  private idAzienda: number;
  private idAttivita: number;
  private settoriSelected: any;
  private selection: any;
  private listaSelection: any;

  private lastname: string;
  private name: string;
  private email: string;

  private statoPeriodoIscrizione: boolean;
  private dataFineAttivita: string;

  private lastnameRules: [boolean | string];
  private nameRules: [boolean | string];
  private emailRules: [boolean | string];

  constructor() {
    super();
    this.dialog = false;
    this.articolazioni = [];
    this.idIstituto = 0;
    this.idAzienda = 0;
    this.idAttivita = 0;
    this.settoriSelected = [];
    this.selection = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "più di 10"];
    this.lastname = "";
    this.name = "";
    this.email = "";
    this.listaSelection = [];

    this.lastnameRules = [true];
    this.nameRules = [true];
    this.emailRules = [true];

    this.statoPeriodoIscrizione = false;
    this.dataFineAttivita = "";
  }

//   aggiungiRisposta(value: any, idDomanda: string) {
//     let alreadyExist: boolean = false;
//     let indiceRisposta: any;
//     let valoreRisposta: string = "";
//     // if (typeof value === "string") {
//     valoreRisposta = value;
//     // }
//     alreadyExist = this.listaSelection.some(
//       (risposta: any) => risposta["idDomanda"] === idDomanda
//     );
//     if (alreadyExist) {
//       indiceRisposta = this.listaSelection.findIndex(
//         (risposta: any) => risposta.idDomanda === idDomanda
//       );
//       this.listaSelection[indiceRisposta].risposta = valoreRisposta;
//     } else {
//       this.listaSelection.push({
//         idDomanda: idDomanda,
//         risposta: valoreRisposta
//       });
//     }
//   }

  loadArticolazioni() {
    var articolazione = {
      idArticolazione: "",
      nomArticolazione: ""
    };
    var articolazioni: any[] = [];
    data
      .dispatchArticolazioni(this["$store"], this.idIstituto)
      .then(response => {
        response.forEach(function(element: any) {
          articolazione = {
            idArticolazione: element.idArticolazione,
            nomArticolazione: element.nomeArticolazione
          };
          articolazioni.push(articolazione);
        });
        this.articolazioni = articolazioni;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  checkSettori() {
    if (this.settoriSelected.length > 0) {
        this.save();
    } else {
      bus.$emit("errorOperation", "Selezionare almeno un settore di interesse");
    }
  }

  async executeTest() {
  }

  save() {
    var payload = {
      idAttivita: this.idAttivita,
      idAzienda: this.idAzienda
    };
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {         
        activity
          .dispatchSubscribeToActivityAzienda(this["$store"], payload)
          .then((idIscrizione: number) => {
            this.settoriSelected.forEach((selezione: any) => {
              var payload2 = {
                idAzienda: this.idAzienda,
                idIscrizione: idIscrizione,
                scelta: {
                  idArticolazione: selezione
                }
              };
              activity
                .dispatchAddColloquioPreference(this["$store"], payload2)
                .then(() => {
                  bus.$emit(
                    "successfullOperation",
                    "Iscrizione ai colloqui avvenuta con successo"
                  );
                  this.dialog = false;
                })
                .catch(error => {
                  if (error.response.status === 403) {
                    bus.$emit("errorOperation", error.response.statusText);
                    this["$router"].push("/login");
                  } else {
                    bus.$emit("errorOperation", error.response.statusText);
                  }
                });
            });
            router.push({
              name: "colloquiAzienda",
              params: {
                idIstituto: String(this.idIstituto),
                idAnnoScolastico: String(idAnnoScolastico),
                idIscrizioneAttivita: String(idIscrizione),
                statoPeriodoIscrizione: String(this.statoPeriodoIscrizione),
                dataFineAttivita: String(this.dataFineAttivita)
              }
            });
          })
          .catch(error => {
            if (error.response.status === 403) {
              bus.$emit("errorOperation", error.response.statusText);
              this["$router"].push("/login");
            } else {
              bus.$emit("errorOperation", error.response.statusText);
            }
          });
      }
    });
  }

  close() {
    this.dialog = false;
    this.articolazioni = [];
    this.idIstituto = 0;
    this.settoriSelected = [];
    this.selection = ["1", "2", "più di 2", "tra 5 e 10", "più di 10"];
    this.lastname = "";
    this.name = "";
    this.email = "";
    this.listaSelection = [];

    this.lastnameRules = [true];
    this.nameRules = [true];
    this.emailRules = [true];
  }

  created() {
    bus.$on("openColloquioSubscription", (data: any) => {
      this.dialog = true;
      this.idIstituto = data.idIstituto;
      this.idAttivita = data.idAttivita;
      this.idAzienda = data.idAzienda;
      this.statoPeriodoIscrizione = data.statoPeriodoIscrizione;
      this.dataFineAttivita = data.dataFineAttivita;
      this.loadArticolazioni();
    });
  }
}
